
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3gB8p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("8tITR")).AgilePageLayout; });

var $8tITR = parcelRequire("8tITR");

});
parcelRegister("8tITR", function(module, exports) {

$parcel$export(module.exports, "AgilePageLayout", function () { return $347fe80be47a6159$export$ec9acf8ba54ff52d; });
/* agile-page-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $5ohHq = parcelRequire("5ohHq");

var $XSYWD = parcelRequire("XSYWD");

var $ibGVp = parcelRequire("ibGVp");
const $347fe80be47a6159$var$agilePageLayoutCss = null; // NOTE: Nested selectors are necessary here to be able to style the dangerouslySetInnerHTML blob
const $347fe80be47a6159$var$articleStyles = null; // Used for Agile Articles, Tutorial, and the Agile Coach pages
const $347fe80be47a6159$export$ec9acf8ba54ff52d = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _yv0eaigu _2z05f5ih _1bah1yb4 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _bozgzwfg _y4tizwfg _zulp1tcg _1bsb1osq _1q51zwfg _85i5ckbl _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx _dbjg1wug _1hvk1wug _isu41wug _15qm1wug _pdlmzwfg"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $XSYWD.AgileHubSideNav), {
                nodes: (0, $ibGVp.useAgileHubPageTreeData)()
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("article", {
                className: (0, $esG4f.default)([
                    "_1461kb7n _f0zu1mrw _dz5jegat _125x18q9 _q7gq1cby _zcqx14u8 _8v2fqlpn _1yziqlpn _1601qlpn _l5k1bfng _r8ntbfng _1a7kbfng _cg411tj6 _qliy1tj6 _1rhq1tj6 _11eb1k8s _17z415sy _qc0pahaf _ggmh1k92 _1axi11ph _1o6v7vkz _ugctnl7k _1edj1k8s _8kc91k92 _1euycjiy _k6x07vkz _8lldnl7k",
                    "main-content"
                ]),
                style: {
                    "--_nmjf06": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.secondary.navy")),
                    "--_1h6bnby": (0, $43MIc.default)((0, $5ohHq.wacToken)("font.charlie.display")),
                    "--_1tgiy09": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.extended.blue900"))
                },
                children: children
            })
        ]
    });
};
var $347fe80be47a6159$export$2e2bcd8739ae039 = $347fe80be47a6159$export$ec9acf8ba54ff52d;

});


parcelRegister("bnSCE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("6sYN8")).ArticleShare; });

var $6sYN8 = parcelRequire("6sYN8");

});
parcelRegister("6sYN8", function(module, exports) {

$parcel$export(module.exports, "ArticleShare", function () { return $4f41c6afbc578d46$export$8316e2489e314828; });
/* article-share.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $baiMc = parcelRequire("baiMc");
const $4f41c6afbc578d46$var$ArticleShareContainerStyle = null;
const $4f41c6afbc578d46$var$ColumnStyles = null;
const $4f41c6afbc578d46$export$8316e2489e314828 = ({ description: description, link: link, title: title, source: source })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _bfhku67f _1tke1n2x _1n261g80 _s7n41q9y"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_1e0c1txw _1bsb1osq _2lx21bp4 _1aax1e5h _ca0qidpf _u5f3gktf _n3tdidpf _19bvgktf _kqswh2mm _19pk1wug _2hwx1wug _otyr1wug _18u01wug"
            ]),
            children: description && link && title && /*#__PURE__*/ (0, $loA2J.jsx)((0, $baiMc.SocialShareMenu), {
                description: description,
                link: link,
                title: title,
                source: source
            })
        })
    });
};

});
parcelRegister("baiMc", function(module, exports) {

$parcel$export(module.exports, "SocialShareMenu", function () { return $18239fd81c7e3271$export$22d14db7e0bd3bb5; });
/* social-share-menu.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");
const $18239fd81c7e3271$var$socialShareButtonStyle = {
    base: "_1e0c1o8l _1bsb1u1b _4t3i1u1b _1reo15vq _18m915vq",
    facebook: "_11q7153z _1lrw1osq",
    twitter: "_1itk1dl8 _12vemgnk _1lrw1osq _uokl1h6o",
    linkedin: "_1itk7ct8 _12vemgnk _1lrw1osq"
};
const $18239fd81c7e3271$var$SocialShareButtonActions = {
    facebook: {
        action: "https://www.facebook.com/dialog/feed",
        params: (props)=>({
                app_id: "743864389089816",
                caption: props.title,
                link: props.link,
                description: props.description,
                picture: "",
                name: props.title
            })
    },
    twitter: {
        action: "https://twitter.com/share",
        params: (props)=>({
                text: props.description,
                url: props.link,
                via: props.source
            })
    },
    linkedin: {
        action: "https://www.linkedin.com/shareArticle",
        params: (props)=>({
                mini: "true",
                url: props.link,
                title: props.title,
                summary: props.description,
                source: props.source
            })
    }
};
const $18239fd81c7e3271$export$49e0960a058fa5ad = ({ title: title, variant: variant, action: action })=>{
    const href = (0, $iSvIT.useMemo)(()=>{
        const actionDescriptor = $18239fd81c7e3271$var$SocialShareButtonActions[variant];
        const url = new URL(actionDescriptor.action);
        const params = new URLSearchParams(actionDescriptor.params(action));
        for (const [key, value] of params.entries())url.searchParams.set(key, value);
        return url.href;
    }, [
        variant,
        action
    ]);
    const clickHandler = (0, $iSvIT.useCallback)((e)=>{
        if (typeof window !== "undefined") {
            window.open(href, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600");
            e.preventDefault();
        }
    }, [
        href
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        "aria-label": "Share to Social Media",
        href: href,
        title: title,
        onClick: clickHandler,
        className: (0, $esG4f.default)([
            $18239fd81c7e3271$var$socialShareButtonStyle.base,
            $18239fd81c7e3271$var$socialShareButtonStyle[variant]
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            style: {
                pointerEvents: "none",
                visibility: "hidden"
            },
            children: title
        })
    });
};
const $18239fd81c7e3271$var$socialShareMenuItemStyle = null;
const $18239fd81c7e3271$var$socialShareMenuStyle = null;
const $18239fd81c7e3271$var$shareTextStyle = null;
const $18239fd81c7e3271$export$22d14db7e0bd3bb5 = ({ description: description, link: link, title: title, source: source })=>{
    const intl = (0, $f6qj2.default)();
    const action = (0, $iSvIT.useMemo)(()=>({
            title: title,
            description: description,
            link: link,
            source: source !== null && source !== void 0 ? source : "Atlassian"
        }), [
        description,
        link,
        title,
        source
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_syaz1bqd _1e0c1txw _2lx21bp4 _y3gn1e5h",
                    "eyebrow-md"
                ]),
                children: intl.formatMessage({
                    id: "Agile.article.share",
                    defaultMessage: "Share this article"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("ul", {
                className: (0, $esG4f.default)([
                    "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                        className: (0, $esG4f.default)([
                            "_4t3i1u1b _7hrg14y2 _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($18239fd81c7e3271$export$49e0960a058fa5ad, {
                            variant: "facebook",
                            action: action,
                            title: intl.formatMessage({
                                id: "Agile.share-menu.facebook",
                                defaultMessage: "Share on Facebook"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                        className: (0, $esG4f.default)([
                            "_4t3i1u1b _7hrg14y2 _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($18239fd81c7e3271$export$49e0960a058fa5ad, {
                            variant: "twitter",
                            action: action,
                            title: intl.formatMessage({
                                id: "Agile.share-menu.twitter",
                                defaultMessage: "Share on Twitter"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                        className: (0, $esG4f.default)([
                            "_4t3i1u1b _7hrg14y2 _ca0qyh40 _u5f3yh40 _n3tdyh40 _19bvyh40"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)($18239fd81c7e3271$export$49e0960a058fa5ad, {
                            variant: "linkedin",
                            action: action,
                            title: intl.formatMessage({
                                id: "Agile.share-menu.linkedin",
                                defaultMessage: "Share on LinkedIn"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

});



parcelRegister("h6PiC", function(module, exports) {

$parcel$export(module.exports, "AgileBreadcrumbs", function () { return $6a5b4d3fc20315ca$export$2ce562bcf8da2de8; });

var $loA2J = parcelRequire("loA2J");

var $1UUq1 = parcelRequire("1UUq1");

var $4XrxY = parcelRequire("4XrxY");

var $ibGVp = parcelRequire("ibGVp");

var $2OqHh = parcelRequire("2OqHh");

var $lrVTP = parcelRequire("lrVTP");
const $6a5b4d3fc20315ca$export$71ac4f9beafb009b = (paths)=>{
    const agileTree = (0, $ibGVp.useAgileHubPageTreeData)();
    const names = paths.map((path)=>{
        if (path === "/agile") return {
            name: "Agile",
            path: "/agile"
        };
        const node = agileTree.find((obj)=>path.includes(obj.urlSlug));
        if (node) {
            if (path === node.urlSlug) return {
                name: node.name,
                path: node.urlSlug
            };
            else {
                const childNode = node.children && node.children.find((obj)=>path === obj.urlSlug);
                if (childNode) return {
                    name: childNode.name,
                    path: childNode.urlSlug
                };
            }
        }
        return {
            name: "",
            path: ""
        };
    });
    return names;
};
const $6a5b4d3fc20315ca$export$2ce562bcf8da2de8 = ()=>{
    const location = (0, $lrVTP.useLocation)();
    const { pathname: pathname } = location;
    const segmentPaths = (0, $2OqHh.getProgressivePathSegments)(pathname);
    const segmentObjs = $6a5b4d3fc20315ca$export$71ac4f9beafb009b(segmentPaths);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Row), {
        layout: "12",
        alignItems: "top",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Breadcrumbs), {
            links: segmentObjs
        })
    });
};

});
parcelRegister("2OqHh", function(module, exports) {

$parcel$export(module.exports, "getProgressivePathSegments", function () { return $6445275238d5e176$export$d491212abeef3206; });

var $igbrG = parcelRequire("igbrG");
const $6445275238d5e176$export$d491212abeef3206 = (path)=>{
    let proPath = "/";
    if (!path || !path.startsWith("/")) return [];
    return path.split("/").filter(Boolean) // remove empty array elements
    .filter((p)=>!(0, $igbrG.isValidLocale)(p)).map((value)=>{
        proPath += `${value}/`;
        return proPath.replace(/\/$/, "");
    });
};

});


parcelRegister("gDqhU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("lTwyn")).AgileHeading; });

var $lTwyn = parcelRequire("lTwyn");

});
parcelRegister("lTwyn", function(module, exports) {

$parcel$export(module.exports, "AgileHeading", function () { return $3da6520e2c550ecc$export$9f1161956c98afd6; });
/* agile-heading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $dyrzP = parcelRequire("dyrzP");

var $lHB9W = parcelRequire("lHB9W");
const $3da6520e2c550ecc$var$headerStyles = null;
const $3da6520e2c550ecc$var$eyebrowStyles = null;
const $3da6520e2c550ecc$var$h1Styles = null;
const $3da6520e2c550ecc$var$pStyles = null; // TODO: Switch to shared Article Grid component
// or at least exported widths/paddings, once in place
const $3da6520e2c550ecc$var$contentBlockStyles = null;
const $3da6520e2c550ecc$var$authorStyles = null;
const $3da6520e2c550ecc$var$headshotStyles = null;
const $3da6520e2c550ecc$export$9f1161956c98afd6 = ({ title: title, eyebrow: eyebrow, description: description, imageUrl: imageUrl, author: author })=>{
    var _author_authorPicture;
    return /*#__PURE__*/ (0, $loA2J.jsx)("header", {
        style: imageUrl ? {
            backgroundImage: `url(${imageUrl})`
        } : undefined,
        className: (0, $esG4f.default)([
            "_1lrw1dfr _1rjc1jly _1e0c11p5 _4cvr1h6o _6a6z1h6o"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1bsb1osq _p12fzqdx _ca0q1j6v _u5f3viql _n3tdidpf _19bvviql _bfhku67f _su071wqb"
            ]),
            children: [
                eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_syazvwuj _1wyboqnp _1dyzt94y _vwz4cs5v _1p1dangw",
                        "eyebrow-sm"
                    ]),
                    children: eyebrow
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_k48pbfng _1wyb1lne _1pfh7vkz _6rth7vkz _1dyzidpf _vwz410nf _syaz1bqd _d8hs1tcg"
                    ]),
                    children: title
                }),
                description && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_1wyb1k92 _vwz419ii _6rth7vkz _syaz1bqd _1tnt1tcg",
                        "body-lg"
                    ]),
                    children: description
                }),
                author && /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                    className: (0, $esG4f.default)([
                        "_1wyboxwj _1e0c1txw _zulp1j6v _4cvr1h6o _1p1dangw",
                        "body-sm"
                    ]),
                    children: [
                        ((_author_authorPicture = author.authorPicture) === null || _author_authorPicture === void 0 ? void 0 : _author_authorPicture.url) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dyrzP.default), {
                            src: author.authorPicture.url,
                            baseWidth: 36,
                            width: 36,
                            height: 36,
                            alt: "",
                            className: (0, $esG4f.default)([
                                "_2rko1ssb _1bsbahaf _4t3iahaf _5ral1dfr"
                            ])
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                            id: "agile.heading.author.byline",
                            defaultMessage: "by {authorName}",
                            values: {
                                authorName: (0, $lHB9W.expectContent)(author.name, "Author name not found")
                            }
                        })
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("eCYM9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("hQj9g")).AgileIntroduction; });

var $hQj9g = parcelRequire("hQj9g");

});
parcelRegister("hQj9g", function(module, exports) {

$parcel$export(module.exports, "AgileIntroduction", function () { return $47e2e782a3f37a0c$export$e27c7ba731ddc3de; });
/* agile-introduction.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $6O6jV = parcelRequire("6O6jV");

var $24ahW = parcelRequire("24ahW");

var $kPtGB = parcelRequire("kPtGB");

var $krNyQ = parcelRequire("krNyQ");
const $47e2e782a3f37a0c$var$headingStyle = null;
const $47e2e782a3f37a0c$var$contentWrapperCss = null;
const $47e2e782a3f37a0c$export$e27c7ba731ddc3de = ({ heading: heading, description: description, image: image, embedLink: embedLink, body: body })=>{
    var _image_description;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            heading && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1pfhidpf"
                ]),
                children: heading
            }),
            description && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthgktf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $krNyQ.RichTextComponent), {
                    text: description,
                    name: null
                })
            }),
            embedLink && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthgktf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6O6jV.AgileVideo), {
                    embedLink: embedLink,
                    title: (_image_description = image === null || image === void 0 ? void 0 : image.description) !== null && _image_description !== void 0 ? _image_description : "",
                    thumbnail: image !== null && image !== void 0 ? image : null
                })
            }),
            image && !embedLink && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_6rthgktf"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kPtGB.BodyAssetComponent), {
                    asset: image
                })
            }),
            body === null || body === void 0 ? void 0 : body.map((component, idx)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    className: (0, $esG4f.default)([
                        "_6rthgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $24ahW.RichContent), (0, $7Knp0._)({}, component))
                }, idx))
        ]
    });
};

});



//# sourceMappingURL=agile-article.bf446979.js.map
